<div class="rediferidos-container">
    <div class="section-card">
        <div class="search-form">
            <div class="search-fields">
                <div class="field-group">
                    <label class="field-label">Perfil:</label>
                    <app-select
                        [options]="perfiles"
                        labelKey="nombrePerfil"
                        codeKey="codPerfil"
                        [showCode]="true"
                        placeholder="Seleccione un perfil"
                        size="s-small"
                        customClass="gray"
                        [(value)]="perfilSeleccionado">
                    </app-select>
                </div>

                <div class="field-group">
                    <label class="field-label">No. de identificacion:</label>
                    <app-input
                        placeholder="Numero de cedula"
                        type="text"
                        size="s-small"
                        customClass="gray"
                        [maxlength]="15"
                        [onlyNumbers]="true"
                        [(value)]="documento">
                    </app-input>
                </div>
            </div>

            <div class="search-actions">
                <button
                mat-flat-button
                color="primary"
                class="btn-buscar"
                (click)="buscarCliente()"
                [disabled]="!habilitarBuscar || cargandoCliente">
                <mat-icon>search</mat-icon>
                Buscar
                </button>
                <button mat-stroked-button class="btn-limpiar" (click)="resetTodo()">
                <mat-icon>close</mat-icon>
                Limpiar
                </button>
            </div>
        </div>
    </div>

    <div class="section-card section-card--loading" *ngIf="cargandoCliente">
        <mat-spinner diameter="24"></mat-spinner>
        <span class="loading-text">Consultando cliente...</span>
    </div>

    <div class="section-card section-card--error" *ngIf="clienteNoEncontrado && !cargandoCliente">
        <mat-icon class="state-icon state-icon--error">error_outline</mat-icon>
        <span class="state-text state-text--error">No se encontro informacion para el documento ingresado.</span>
    </div>

    <div class="section-card section-card--success" *ngIf="aplicadoExitoso">
        <mat-icon class="state-icon state-icon--success">check_circle</mat-icon>
        <span class="state-text state-text--success">{{ mensajeAplicado }}</span>
    </div>

    <div class="section-card section-card--warning" *ngIf="noAceptacionExitosa">
        <mat-icon class="state-icon state-icon--warning">info</mat-icon>
        <span class="state-text state-text--warning">{{ mensajeNoAceptacion }}</span>
    </div>

    <ng-container *ngIf="cliente && !cargandoCliente && !clienteNoEncontrado">
        <div class="section-card">
            <div class="card-header">
            <div class="card-header-icon">
                <mat-icon>person</mat-icon>
            </div>
            <h3 class="card-header-title">Informacion del cliente</h3>
            </div>

            <div class="stats-grid">
            <div class="stat-item">
                <div class="stat-label">
                <mat-icon>credit_card</mat-icon>
                <span>Cedula</span>
                </div>
                <span class="stat-value">{{ cliente.nIde }}</span>
            </div>

            <div class="stat-item">
                <div class="stat-label">
                <mat-icon>person</mat-icon>
                <span>Nombre</span>
                </div>
                <span class="stat-value">{{ cliente.nombreTitular }}</span>
            </div>

            <div class="stat-item">
                <div class="stat-label">
                <mat-icon>account_balance_wallet</mat-icon>
                <span>Cuenta</span>
                </div>
                <span class="stat-value">{{ cliente.cue }}</span>
            </div>

            <div class="stat-item">
                <div class="stat-label">
                <mat-icon>attach_money</mat-icon>
                <span>Total</span>
                </div>
                <span class="stat-value stat-value--highlight">
                {{ cliente.total | currency:'COP':'symbol-narrow':'1.0-0' }}
                </span>
            </div>

            <div class="stat-item">
                <div class="stat-label">
                <mat-icon>account_balance</mat-icon>
                <span>Saldo</span>
                </div>
                <span class="stat-value stat-value--highlight">
                {{ cliente.saldo | currency:'COP':'symbol-narrow':'1.0-0' }}
                </span>
            </div>

            <div class="stat-item">
                <div class="stat-label">
                <mat-icon>payment</mat-icon>
                <span>Cuota actual</span>
                </div>
                <span class="stat-value">
                {{ cliente.cuotaActual | currency:'COP':'symbol-narrow':'1.0-0' }}
                </span>
            </div>

            <div class="stat-item">
                <div class="stat-label">
                <mat-icon>warning</mat-icon>
                <span>Saldo vencido</span>
                </div>
                <span class="stat-value stat-value--danger">
                {{ cliente.saldoVencido | currency:'COP':'symbol-narrow':'1.0-0' }}
                </span>
            </div>
            </div>
        </div>

        <div class="section-card" *ngIf="facturas.length > 0">
            <div class="card-header card-header--split">
            <div class="card-header-left">
                <div class="card-header-icon">
                <mat-icon>description</mat-icon>
                </div>
                <div>
                <h3 class="card-header-title">Facturas</h3>
                <p class="card-header-subtitle">
                    {{ facturas.length }} factura{{ facturas.length !== 1 ? 's' : '' }}
                    encontrada{{ facturas.length !== 1 ? 's' : '' }}
                </p>
                </div>
            </div>
            </div>

            <div class="table-wrapper">
                <table class="data-table">
                    <thead>
                    <tr>
                        <th>
                        <div class="th-content">
                            <mat-icon>tag</mat-icon>
                            No. Factura
                        </div>
                        </th>
                        <th>
                        <div class="th-content">
                            <mat-icon>calendar_today</mat-icon>
                            Fecha emision
                        </div>
                        </th>
                        <th class="text-right">
                        <div class="th-content th-content--right">
                            <mat-icon>attach_money</mat-icon>
                            Valor
                        </div>
                        </th>
                        <th class="text-center">
                        <div class="th-content th-content--center">
                            <mat-icon>schedule</mat-icon>
                            Cuotas pendientes
                        </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let f of displayedFacturas; trackBy: trackByFactura" class="table-row">
                        <td>
                        <span class="cell-bold">{{ f.factura }}</span>
                        </td>
                        <td>
                        <span class="cell-muted">{{ f.fechaEmision }}</span>
                        </td>
                        <td class="text-right">
                        <span class="cell-medium">
                            {{ f.valor | currency:'COP':'symbol-narrow':'1.0-0' }}
                        </span>
                        </td>
                        <td class="text-center">
                        <span class="badge"
                            [class.badge--destructive]="f.cuotasPendientes > 1"
                            [class.badge--outline]="f.cuotasPendientes <= 1">
                            {{ f.cuotasPendientes }}
                        </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="show-more" *ngIf="facturas.length > 3">
                <button mat-button class="show-more-btn" (click)="toggleMostrarFacturas()">
                    <mat-icon>{{ showAllFacturas ? 'expand_less' : 'expand_more' }}</mat-icon>
                    {{ showAllFacturas
                    ? 'Ver menos facturas'
                    : 'Ver ' + (facturas.length - 3) + ' factura' + (facturas.length - 3 !== 1 ? 's' : '') + ' mas'
                    }}
                </button>
            </div>
        </div>

        <div class="section-card" *ngIf="dataSource.data.length > 0 && !aplicando">
            <div class="card-header card-header--split">
            <div class="card-header-left">
                <div class="card-header-icon">
                    <mat-icon>calculate</mat-icon>
                </div>

                <div>
                    <h3 class="card-header-title">Simulacion de cuotas</h3>
                    <p class="card-header-subtitle">Opciones disponibles segun el perfil seleccionado</p>
                </div>
            </div>
            </div>

            <div class="loading-inline" *ngIf="cargandoSimulacion">
                <mat-spinner diameter="20"></mat-spinner>
                <span>Calculando simulaciones...</span>
            </div>

            <div class="table-wrapper" *ngIf="!cargandoSimulacion">
            <table mat-table [dataSource]="dataSource" class="data-table mat-data-table">
                <!-- N Cuotas -->
                <ng-container matColumnDef="numeroCuotas">
                    <th mat-header-cell *matHeaderCellDef>N. Cuotas</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cuota-badge">{{ row.numeroCuotas }}</span>
                    </td>
                </ng-container>

                <!-- Capital -->
                <ng-container matColumnDef="capital">
                    <th mat-header-cell *matHeaderCellDef class="text-right">Capital</th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                        {{ row.capital | currency:'COP':'symbol-narrow':'1.0-0' }}
                    </td>
                </ng-container>

                <!-- Intereses -->
                <ng-container matColumnDef="intereses">
                    <th mat-header-cell *matHeaderCellDef class="text-right">Intereses</th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                        {{ row.intereses | currency:'COP':'symbol-narrow':'1.0-0' }}
                    </td>
                </ng-container>

                <!-- Seguro -->
                <ng-container matColumnDef="seguro">
                    <th mat-header-cell *matHeaderCellDef class="text-right">Seguro</th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                        {{ row.seguro | currency:'COP':'symbol-narrow':'1.0-0' }}
                    </td>
                </ng-container>

                <!-- Seguro Millon -->
                <ng-container matColumnDef="seguroMillon">
                    <th mat-header-cell *matHeaderCellDef class="text-right">Seguro Millon</th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                        {{ row.seguroMillon | currency:'COP':'symbol-narrow':'1.0-0' }}
                    </td>
                </ng-container>

                <!-- Valor Cuota -->
                <ng-container matColumnDef="valorCuota">
                    <th mat-header-cell *matHeaderCellDef class="text-right">Valor cuota</th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                        <span class="cell-bold">
                        {{ row.valorCuota | currency:'COP':'symbol-narrow':'1.0-0' }}
                        </span>
                    </td>
                </ng-container>

                <!-- Tasa -->
                <ng-container matColumnDef="tasa">
                <th mat-header-cell *matHeaderCellDef class="text-right">Tasa</th>
                <td mat-cell *matCellDef="let row" class="text-right">
                    <span class="cell-muted">{{ row.tasa | number:'1.6-6' }} %</span>
                </td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <div class="row-actions">
                    <button mat-button class="btn-ver-cuotas" (click)="verDetalles(row.simulacion)">
                        <mat-icon>visibility</mat-icon>
                        <span class="action-label">Ver cuotas</span>
                    </button>

                    <button mat-flat-button color="primary" class="btn-aplicar" (click)="aplicarSimulacion(row.simulacion)">
                        <span class="action-label">Aplicar</span>
                    </button>
                    </div>
                </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-row"></tr>
            </table>
            </div>

            <mat-paginator
            #simulacionPaginator
            [pageSizeOptions]="[5, 10, 20]"
            [pageSize]="5"
            showFirstLastButtons
            class="custom-paginator">
            </mat-paginator>
        </div>

        <div class="section-card section-card--loading" *ngIf="aplicando">
            <mat-spinner diameter="24"></mat-spinner>
            <span class="loading-text">Aplicando rediferido a cartera...</span>
        </div>

        <div class="section-card" *ngIf="!aplicando && !cargandoSimulacion && dataSource.data.length > 0 && !aplicadoExitoso && !noAceptacionExitosa">
            <div class="card-header card-header--danger">
                <div class="card-header-icon card-header-icon--danger">
                    <mat-icon>gpp_bad</mat-icon>
                </div>
                
                <h3 class="card-header-title">No aceptacion de rediferido</h3>
            </div>

            <div class="rejection-content">
                <div class="rejection-field">
                    <label class="field-label">Seleccione la causal de no aceptacion:</label>

                    <app-select
                    [options]="causales"
                    labelKey="nombre"
                    valueKey="cod_causal"
                    placeholder="Seleccione una causal"
                    size="s-small"
                    customClass="gray"
                    [(value)]="causalSeleccionada">
                    </app-select>
                </div>

                <button mat-flat-button
                    color="warn"
                    class="btn-rejection"
                    (click)="enviarNoAceptacion()"
                    [disabled]="!causalSeleccionada || aplicandoNoAceptacion">
                    <mat-icon *ngIf="!aplicandoNoAceptacion">send</mat-icon>
                    <mat-spinner *ngIf="aplicandoNoAceptacion" diameter="18"></mat-spinner>
                    {{ aplicandoNoAceptacion ? 'Enviando...' : 'Enviar no aceptacion' }}
                </button>
            </div>
        </div>
    </ng-container>
  </div>